<template>
  <div>
    <div style="padding: 10px 5px;">
      <el-button size="mini" round type="primary" @click="addCate">新增职能模块</el-button>
      &nbsp;<span style="color:#545454">搜索请按Ctrl+F，输入要搜的内容并回车</span>
    </div>
    <el-table :data="catData" style="width: 100%">
      <el-table-column fixed="left" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="mini" :disabled="!hasEditPerm" @click="editCate(scope.row)">修改</el-button>
          <el-button type="text" size="mini" :disabled="!hasEditPerm" @click="delCate(scope.row, scope.$index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="名称" label="名称" sortable width="200"> </el-table-column>
      <el-table-column prop="类型" label="类型" sortable width="200"
        ><template slot-scope="scope">
          {{ joinArr(scope.row['类型']) }}
        </template>
      </el-table-column>
      <el-table-column prop="大职能板块" label="大职能板块" sortable width="200"> </el-table-column>
      <el-table-column label="负责人" width="100">
        <template slot-scope="scope">
          {{ joinArr(scope.row['负责人']) }}
        </template>
      </el-table-column>
      <el-table-column label="细分职能">
        <template slot-scope="scope">
          {{ joinArr(scope.row['二级职能']) }}
        </template>
      </el-table-column>
      <el-table-column label="擅长方向">
        <template slot-scope="scope">
          {{ joinArr(scope.row['擅长方向']) }}
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      class="radish-dia"
      :title="title"
      top="70px"
      :modal="false"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form ref="form" :model="form" label-width="200px">
        <el-form-item label="名称"> <el-input v-model="form['名称']"></el-input> </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="form['类型']" placeholder="请选择" multiple filterable>
            <el-option v-for="item in types" :key="item.value" :label="item.value" :value="item.value">
              <span>{{ item.label }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="大职能板块"> <el-input v-model="form['大职能板块']"></el-input> </el-form-item>
        <el-form-item label="负责人">
          <el-select v-model="form['负责人']" multiple filterable placeholder="请选择">
            <el-option v-for="item in accounts" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="细分职能(输入并回车添加)">
          <el-select
            v-model="form['二级职能']"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="请选择"
          >
          </el-select>
        </el-form-item>
        <el-form-item label="擅长方向(输入并回车添加)">
          <el-select
            v-model="form['擅长方向']"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="请选择"
          >
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="saveCate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      dialogVisible: false,
      catData: [],
      form: {},
      accounts: [],
      title: '',
      types: [
        // '通用-职能',
        // '金融-职能',
        // '咨询-职能',
        // '互联网-职能',
        // '消费-职能',
        // '零售-职能',
        // '新零售-职能',
        // '医药器械-职能',
        // '医疗大健康-职能',
        // '交通贸易-职能',
        // '广告-职能',
        // '文化传媒-职能',
        // '教育-职能',
        // '机械制造-职能',
        // '房地产-职能',
        // '电子通讯-职能',
        // '餐饮旅游-职能',
        // '服务外包-职能',
        // '农林牧渔-职能',
        // '能源化工-职能',
        // '政府/公共事业/非营利机构-职能',
        // '其他-职能',
        // '芯片-职能',
        // '医疗-职能',
      ],
    }
  },
  computed: {
    hasEditPerm() {
      const hasPermRoles = [
        '管理员',
        '猎头顾问',
        'mac用户',
        '团队长',
        '高管',
        '助理顾问',
        '人力',
        '高级顾问',
        '行政',
        '微名片管理员',
        '财务',
      ]
      let hasPerm = false
      if (app.user.角色 && app.user.角色.length > 0) {
        hasPerm = hasPermRoles.some(v => app.user.角色.includes(v))
      }
      return hasPerm
    },
  },
  mounted: function() {
    Promise.all([this.loadAccount(), this.loadCate(), this.loadIndustry()])
  },
  methods: {
    loadCate: async function() {
      const inds = await app.service('misc').listIndustries()
      if (inds.status == 'success') {
        const types = inds.data.map(v => {
          return { label: `${v.大行业}-${v.名称}`, value: v.名称 }
        })
        types.unshift({ label: '通用职能', value: '通用职能' })
        this.types = types
      }
    },
    loadIndustry: async function() {
      const cats = await app.service('misc').listCategories()
      if (cats.status == 'success') {
        this.catData = cats.data
      }
    },
    loadAccount: async function() {
      const res = await app.service('misc').listAccounts()
      // console.log(res)
      if (res.status == 'success') {
        this.accounts = res.data.map(u => u.account)
      }
    },
    addCate: async function() {
      this.title = '新增职能模块'
      this.form = {}
      this.dialogVisible = true
    },
    saveCate: async function() {
      const dt = JSON.parse(JSON.stringify(this.form))
      let res
      if (dt._id) {
        res = await app.service('misc').modifyCategory({ _id: dt._id, data: dt })
      } else {
        res = await app.service('misc').addCategory(dt)
      }
      if (res.status == 'success') {
        this.$message.success(res.msg)
        this.loadCate()
      }
      this.dialogVisible = false
    },
    editCate: function(row) {
      this.title = '修改职能模块'
      this.form = row
      this.dialogVisible = true
    },
    delCate: async function(row, index) {
      const res = await app.service('misc').delCategory({ _id: row._id })
      if (res.status == 'success') {
        this.$message.success('删除成功')
        this.catData.splice(index, 1)
      }
    },
    joinArr: function(arr) {
      if (!arr || !(arr instanceof Array)) return arr || ''
      return arr.join(';')
    },
  },
}
</script>
